module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "structure-nxt"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Inspirational Quotes ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("&")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Affirmations to Live By")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "yellow CharOverride-6"
  }, [_vm._v("June Cotner")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/MangoPublishingLogo.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Coral Gables")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-GRAY ParaOverride-1"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d6e5436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97816425039441.vue
// module id = 63
// module chunks = 0